import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import i18n from '../../../i18n';
import Spinner from '../../../components/Spinner';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import PdfGroupModal from './PdfGroupModalEquipamentos';
import PopupPDF from './popUpPdf';
// import MultiSelect from '../../Selects/MultiSelect';
import axios from 'axios';
import {Collapse, initTE} from 'tw-elements';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';

import {
    artigosFiltrados,
    getClientes,
    getDados,
    getEtapas,
    getEtapasTxt,
    getProdutos,
    getCatalogo,
    getMarcas,
    getModelos,
    getVersoes,
    getTipos,
    getNacionaisInternacionais,
    getCategoriasArtigos,
} from '../../../pages/requests';

import DrawerFilter from '../DrawerFilter';
import QuantidadeItemModal from '../QuantidadeItemModal';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
import NotFound from '../../NotFound';
import SelectComponent from '../../Selects/SelectFilter';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import LoadingModal from '../../LoadingModal';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';
import imageDark from '../../../assets/images/ImageDark.png';
import imagelight from '../../../assets/images/ImageLight.png';
// import MultiSelectFilt from '../../Selects/MultiSelectFilt';
import {MultiSelect} from 'react-multi-select-component';

function Table({
    setHideTable,
    onRowClick,
    setNomeItem,
    setCodigoItem,
    filtroReferencia,
    setFiltroReferencia,
    filtroCategoria,
    setFiltroCategoria,
    filtroMarca,
    setFiltroMarca,
    setFiltroNacionalInternacional,
    filtroNacionalInternacional,
    filtroTipo,
    setFiltroTipo,
    filtroModelo,
    setFiltroModelo,
    filtroVersao,
    setFiltroVersao,
    filtroCStock,
    setFiltroCStock,
    loading,
    setLoading,
    optionsCategorias,
    optionsMarca,
    optionsModelo,
    optionsNacionaisInternacionais,
    optionsTipo,
    optionsVersao,
}) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [visitas, setVisitas] = useState([]);
    const [totalItems, setTotalItems] = useState(0);

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [semDados, setSemDados] = useState(false);
    const [artigos, setArtigos] = useState([]);
    const [openQtd, setOpenQtd] = useState(false);
    const [idDocumento, setIdDocumento] = useState('');
    const [loadingTable, setLoadingTable] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [itemCart, setItemCart] = useState();

    const {isCard, catalogoCard, openCards, theme, carrinhoItems, setCarrinhoItems} = useContext(Context);

    const unidades = [
        {value: 'kg', label: 'Quilograma (kg)'},
        {value: 'g', label: 'Grama (g)'},
        {value: 'mg', label: 'Miligrama (mg)'},
        {value: 'l', label: 'Litro (l)'},
        {value: 'ml', label: 'Mililitro (ml)'},
        {value: 'm', label: 'Metro (m)'},
        {value: 'cm', label: 'Centímetro (cm)'},
        {value: 'mm', label: 'Milímetro (mm)'},
        {value: 'un', label: 'Unidade (un)'},
    ];
    const numPg = [
        {value: '5', label: '5'},
        {value: '10', label: '10'},
        {value: '15', label: '15'},
        {value: '20', label: '20'},
    ];

    // const [artigosList, setArtigosList] = useState([]);

    const incrementarQuantidade = id => {
        setArtigos(prevArtigos => {
            return prevArtigos.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        quantidade: (item.quantidade || 0) + 1,
                    };
                }
                return item;
            });
        });
    };
    const changeSelect = (e, dados) => {
        const novoValor = e.target.value;
        setArtigos(prevArtigos => {
            return prevArtigos.map(item => {
                if (item.id === dados.id) {
                    return {
                        ...item,
                        unidade: novoValor,
                    };
                }
                return item;
            });
        });
    };

    const decrementarQuantidade = id => {
        setArtigos(prevArtigos => {
            return prevArtigos.map(item => {
                if (item.id === id && item.quantidade > 0) {
                    return {
                        ...item,
                        quantidade: item.quantidade - 1,
                    };
                }
                return item;
            });
        });
    };

    // // OPTIONS TABELA

    // const [optionsCategorias, setOptionsCategorias] = useState([]);
    // const [optionsMarca, setOptionsMarca] = useState([]);
    // const [optionsNacionaisInternacionais, setOptionsNacionaisInternacionais] =
    //     useState([]);
    // const [optionsTipo, setOptionsTipo] = useState([]);
    // const [optionsModelo, setOptionsModelo] = useState([]);
    // const [optionsVersao, setOptionsVersao] = useState([]);

    // //Filtros tabela
    // const [filtroReferencia, setFiltroReferencia] = useState('');
    // const [filtroCategoria, setFiltroCategoria] = useState([]);
    // const [filtroMarca, setFiltroMarca] = useState([]);
    // const [filtroNacionalInternacional, setFiltroNacionalInternacional] =
    //     useState([]);
    // const [filtroTipo, setFiltroTipo] = useState([]);
    // const [filtroModelo, setFiltroModelo] = useState([]);
    // const [filtroVersao, setFiltroVersao] = useState([]);
    // const [filtroCStock, setFiltroCStock] = useState([]);

    const [totalProdutos, setTotalProdutos] = useState(0);
    const [ITEMS_PER_PAGE, setITEMS_PER_PAGE] = useState(() => {
        const storedValue = localStorage.getItem('ITEMS_PER_PAGE');

        return storedValue ? parseInt(storedValue, 10) : 15;
    });

    useEffect(() => {
        localStorage.setItem('ITEMS_PER_PAGE', ITEMS_PER_PAGE);
    }, [ITEMS_PER_PAGE]);

    const handleAddToCart = item => {
        const existingItemIndex = carrinhoItems?.findIndex(e => e.id === item.id && e.unidade === item.unidade);

        if (existingItemIndex !== -1 && existingItemIndex != null) {
            toast.warn(t('itemExistente'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        } else {
            const novoItem = {
                ...item,
                quantidade: item.quantidade ? item.quantidade : 1,
                unidade: item.unidade ? item.unidade : unidades[0]?.value,
            };

            setCarrinhoItems([...carrinhoItems, novoItem]);
            document.getElementById(`quantidade_${item.id}`).value = 0;
            toast.success(t('addCarrinho'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }
    };

    // const ITEMS_PER_PAGE = 15;

    const handleRowClick = dados => {
        setHideTable(true);
        onRowClick(dados);
        setCodigoItem(dados.id);
        setNomeItem(dados.nome);
    };

    initTE({Collapse});

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    } else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    function HandleSpinner() {
        {
            <Spinner />;
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setLoadingTable(true);
        setArtigos([]);

        const controller = new AbortController();
        const signal = controller.signal;

        getCatalogo(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroReferencia,
            filtroCategoria.map(f => f.value),
            filtroMarca.map(f => f.value),
            filtroNacionalInternacional.map(f => f.value),
            filtroTipo.map(f => f.value),
            filtroModelo.map(f => f.value),
            filtroVersao.map(f => f.value),
        )
            .then(res => {
                if (res.data.success) {
                    setArtigos(res.data.produtos);
                    setTotalProdutos(res.data.totalprodutos);
                } else {
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoadingTable(false);
            });
        HandleSpinner();

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroReferencia, filtroCategoria, filtroMarca, filtroNacionalInternacional, filtroTipo, filtroModelo, filtroVersao, ITEMS_PER_PAGE]);

    function limparFiltros() {
        setFiltroReferencia('');
        setCurrentPage(1);
        setFiltroCategoria([]);
        setFiltroMarca([]);
        setFiltroNacionalInternacional([]);
        setFiltroModelo([]);
        setFiltroTipo([]);
        setFiltroVersao([]);
    }

    const handleChange = () => {
        setFiltroCStock(!filtroCStock);
    };
    console.log(artigos, 'aqui');
    return (
        <div>
            {openQtd && <QuantidadeItemModal cancelar={() => setOpenQtd(false)} item={itemCart} />}
            {isMobile || isCard ? (
                <div>
                    {artigos?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => handleRowClick(dados)}>
                                        {dados.temAnexos == true && (
                                            <span
                                                data-modal-target="defaultModal"
                                                data-modal-toggle="defaultModal"
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    setIdDocumento(dados.id);
                                                }}
                                                className="cursor-pointer flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                <AttachFileRoundedIcon />
                                            </span>
                                        )}
                                        {dados.marca.label} | {dados.categoria.label} | {dados.modelo?.label} | {dados.versao?.label}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="flex flex-row items-center">
                                    <div>{dados.foto && <img className="w-[100px] h-[80px] rounded-[6px]" src={'data:image/jpeg;base64,' + dados.foto} />}</div>
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('categoria')}:</div> {dados.categoria.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('marca')}: </div> {dados.marca.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('nacionalInternacional')}: </div> {dados.nacionalInternacional?.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('tipo')}: </div> {dados.tipo?.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('modelo')}: </div> {dados.modelo?.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('versao')}: </div> {dados.versao?.label}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loadingTable && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-end ml-4 pt-4" aria-label="Table navigation">
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3 w-20"></th>
                                <th scope="col" className="px-4 py-3 w-2"></th>

                                <th scope="col" className="px-2 py-3 w-96">
                                    {t('produto')}
                                    <InputFilter
                                        value={filtroReferencia}
                                        onSearch={value => {
                                            setFiltroReferencia(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3 ">
                                    {t('categoria')}
                                    <div style={{width: '300px'}} className="mt-2">
                                        <MultiSelect
                                            // styles={{maxWidth: 250}}
                                            className={theme == 'dark' ? 'dark' : ''}
                                            options={optionsCategorias}
                                            value={filtroCategoria}
                                            onChange={e => {
                                                setCurrentPage(1);
                                                setFiltroCategoria(e);
                                            }}
                                            
                                            overrideStrings={{
                                                selectSomeItems: t('filtro'),  
                                                allItemsAreSelected:  t('todosItens'),
                                                selectAll: t('selecionarTudo'),
                                                search: t('pesquisar'),
                                                clearSearch: t('limparPesquisa'),
                                            }}
                                            noOptionsMessage={() => t('semopcoes')}
                                        />
                                    </div>
                                </th>
                                <th scope="col" className=" py-3 ">
                                    {t('marca')}
                                    <div style={{width: '300px'}} className="mt-2">
                                        <MultiSelect
                                            className={theme == 'dark' ? 'dark' : ''}
                                            options={optionsMarca.filter(o => filtroCategoria.length === 0 || filtroCategoria.filter(f => f.value === o.dep).length > 0)}
                                            value={filtroMarca}
                                            onChange={e => {
                                                setFiltroMarca(e);
                                                setCurrentPage(1);
                                            }}
                                            overrideStrings={{
                                                selectSomeItems: t('filtro'),  
                                                allItemsAreSelected:  t('todosItens'),
                                                selectAll: t('selecionarTudo'),
                                                search: t('pesquisar'),
                                                clearSearch: t('limparPesquisa'),
                                            }}
                                            noOptionsMessage={() => t('semopcoes')}
                                        />
                                    </div>
                                </th>
                                <th scope="col" className="px-2 py-3 ">
                                    {t('nacionalInternacional')}
                                    <div className="mt-2">
                                        <MultiSelect
                                            className={theme == 'dark' ? 'dark' : ''}
                                            options={!filtroMarca ? optionsNacionaisInternacionais : optionsNacionaisInternacionais.filter(o => filtroMarca.filter(f => f.value === o.dep).length > 0)}
                                            value={filtroNacionalInternacional}
                                            onChange={e => {
                                                setFiltroNacionalInternacional(e);
                                            }}
                                            overrideStrings={{
                                                selectSomeItems: t('filtro'),  
                                                allItemsAreSelected:  t('todosItens'),
                                                selectAll: t('selecionarTudo'),
                                                search: t('pesquisar'),
                                                clearSearch: t('limparPesquisa'),
                                            }}
                                            noOptionsMessage={() => t('semopcoes')}
                                        />
                                    </div>
                                </th>
                                <th scope="col" className="px-2 py-3 ">
                                    {t('tipo')}
                                    <div className="mt-2">
                                        <MultiSelect
                                            className={theme == 'dark' ? 'dark' : ''}
                                            options={!filtroNacionalInternacional ? optionsTipo : optionsTipo.filter(o => filtroNacionalInternacional.filter(f => f.value === o.dep).length > 0)}
                                            value={filtroTipo}
                                            onChange={e => {
                                                setFiltroTipo(e);
                                            }}
                                            overrideStrings={{
                                                selectSomeItems: t('filtro'),  
                                                allItemsAreSelected:  t('todosItens'),
                                                selectAll: t('selecionarTudo'),
                                                search: t('pesquisar'),
                                                clearSearch: t('limparPesquisa'),
                                            }}
                                            noOptionsMessage={() => t('semopcoes')}
                                        />
                                    </div>
                                </th>

                                <th scope="col" className="px-2 py-3 ">
                                    {t('modelo')}
                                    <div className="mt-2">
                                        <MultiSelect
                                            className={theme == 'dark' ? 'dark' : ''}
                                            options={!filtroTipo ? optionsModelo : optionsModelo.filter(o => filtroTipo.filter(f => f.value === o.dep).length > 0)}
                                            value={filtroModelo}
                                            onChange={e => {
                                                setFiltroModelo(e);
                                            }}
                                            overrideStrings={{
                                                selectSomeItems: t('filtro'),  
                                                allItemsAreSelected:  t('todosItens'),
                                                selectAll: t('selecionarTudo'),
                                                search: t('pesquisar'),
                                                clearSearch: t('limparPesquisa'),
                                            }}
                                            noOptionsMessage={() => t('semopcoes')}
                                        />
                                    </div>
                                </th>
                                <th scope="col" className="px-2 py-3 ">
                                    {t('versao')}
                                    <div className="flex flex-row items-center">
                                        <div className="mr-2 w-40 mt-2">
                                            <MultiSelect
                                                className={theme == 'dark' ? 'dark' : ''}
                                                options={optionsVersao.filter(o => filtroModelo.filter(f => f.value === o.dep).length > 0)}
                                                value={filtroVersao}
                                                onChange={e => {
                                                    setFiltroVersao(e);
                                                }}
                                                overrideStrings={{
                                                    selectSomeItems: t('filtro'),  
                                                    allItemsAreSelected:  t('todosItens'),
                                                    selectAll: t('selecionarTudo'),
                                                    search: t('pesquisar'),
                                                    clearSearch: t('limparPesquisa'),
                                                }}
                                                noOptionsMessage={() => t('semopcoes')}
                                            />
                                        </div>
                                        <div></div>
                                        {filtroReferencia ||
                                        filtroCategoria.length ||
                                        filtroMarca.length ||
                                        filtroNacionalInternacional.length ||
                                        filtroModelo.length ||
                                        filtroTipo.length ||
                                        filtroVersao.length ? (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="  flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        ) : null}
                                    </div>
                                </th>
                                <th className="px-2 py-3 w-2"></th>
                            </tr>
                        </thead>
                        {!catalogoCard && (
                            <tbody>
                                {artigos.map(dados => (
                                    <tr
                                        className=" odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                        onClick={() => handleRowClick(dados)}>
                                        <td className=" px-2 py-2"> {dados.foto && <img className="w-[80px] h-[60px] rounded-[6px]" src={'data:image/jpeg;base64,' + dados.foto} />}</td>
                                        <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.temAnexos && (
                                                <span
                                                    data-modal-target="defaultModal"
                                                    data-modal-toggle="defaultModal"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        setIdDocumento(dados.id);
                                                    }}
                                                    className="cursor-pointer flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                    <AttachFileRoundedIcon />
                                                </span>
                                            )}
                                        </th>
                                        <td className="px-6 py-1">
                                            {dados.id} - {dados.nome}
                                        </td>

                                        <td className="px-6 py-1">{dados.categoria.label}</td>
                                        <td className="px-2 py-1">{dados.marca.label}</td>
                                        <td className="px-6 py-1">{dados.nacionalInternacional?.label}</td>
                                        <td className="px-6 py-1">{dados.tipo?.label}</td>
                                        <td className="px-6 py-1">{dados.modelo?.label}</td>
                                        <td className="px-6 py-1">{dados.versao?.label}</td>
                                        <td className="px-2 py-1">{dados.totalStock}</td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>{' '}
                    {catalogoCard && (
                        <>
                            {' '}
                            <div className="flex flex-row flex-wrap justify-start gap-x-9 mt-2 px-4">
                                {artigos.map(dados => (
                                    <div
                                        className="w-full mb-4 max-w-xs  bg-white border border-gray-200  rounded-[8px] shadow dark:bg-gray-800 dark:border-gray-700"
                                        onClick={e => {
                                            handleRowClick(dados);
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}>
                                        {/* <a href="#">
                                        <img className="p-4 rounded-t-lg h-[130px] w-[210px]" src={'data:image/jpeg;base64,' + dados.foto} alt="product image" />
                                    </a> */}
                                        {dados.foto ? (
                                            <div className="flex flex-row justify-center">
                                                <img className="p-4 rounded-t-lg h-[130px] w-[210px]" src={'data:image/jpeg;base64,' + dados.foto} alt="product image" />{' '}
                                            </div>
                                        ) : (
                                            <div className="flex flex-row justify-center h-[130px] py-8">
                                                <img src={theme == 'dark' ? imagelight : imageDark} className="h-20 w-20 " />
                                            </div>
                                        )}

                                        <div className="px-4 pb-4 flex flex-col justify-between h-90">
                                            <div className="h-12">
                                                <a href="#">
                                                    <h5 className="text-md  font-semibold tracking-tight text-gray-900 dark:text-white">
                                                        {' '}
                                                        {dados.id} - {dados.nome}
                                                    </h5>
                                                </a>
                                            </div>
                                            <div>
                                                <p className="font-normal text-md leading-8 text-gray-500 ">{dados.referencia}</p>

                                                <p className="font-normal text-md leading-8 text-gray-500  ">{dados.descricao}</p>
                                                {/* <div className="flex items-center mt-2.5 mb-2">
                                                    <div className="flex items-center space-x-1 rtl:space-x-reverse">
                                                        <svg className="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                        </svg>
                                                        <svg className="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                        </svg>
                                                        <svg className="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                        </svg>
                                                        <svg className="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                        </svg>
                                                        <svg
                                                            className="w-4 h-4 text-gray-200 dark:text-gray-600"
                                                            aria-hidden="true"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="currentColor"
                                                            viewBox="0 0 22 20">
                                                            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                        </svg>
                                                    </div>
                                                    <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ms-3">5.0</span>
                                                </div> */}
                                                <div>
                                                    {' '}
                                                    <span className="text-2xl font-bold text-gray-900 dark:text-white">
                                                        {dados.preco}
                                                        {dados.moeda}
                                                    </span>
                                                </div>
                                                <div>
                                                    {' '}
                                                    <select
                                                        onChange={e => {
                                                            changeSelect(e, dados);
                                                        }}
                                                        value={dados.unidade || unidades[0]?.value}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}
                                                        id="small"
                                                        className="block w-full mt-2 p-2  text-sm text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                        <option selected>{t('escolhaUnidade')}</option>
                                                        {dados?.unidades?.map((unidade, index) => (
                                                            <option key={index} value={unidade.value}>
                                                                {unidade.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="flex items-center justify-between  mt-2">
                                                    <div className="flex items-center max-[500px]:justify-center h-full max-md:mt-3">
                                                        <div className="flex items-center h-full">
                                                            <button
                                                                onClick={e => {
                                                                    decrementarQuantidade(dados.id);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }}
                                                                className="group rounded-l-xl px-2 py-[8px] border border-gray-200    flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 dark:bg-gray-300 dark:hover:bg-gray-200 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                                                <svg
                                                                    className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="12"
                                                                    height="12"
                                                                    viewBox="0 0 22 22"
                                                                    fill="none">
                                                                    <path d="M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                                    <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                                </svg>
                                                            </button>
                                                            <input
                                                                type="text"
                                                                id={`quantidade_${dados.id}`}
                                                                className="border-y border-gray-200 dark:bg-gray-50 outline-none text-gray-900 font-semibold text-lg w-full max-w-[30px] min-w-[20px] placeholder:text-gray-900 py-[4px]  text-center bg-transparent"
                                                                // placeholder="1"
                                                                value={dados.quantidade || 0}
                                                                readOnly
                                                            />
                                                            <button
                                                                onClick={e => {
                                                                    incrementarQuantidade(dados.id);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }}
                                                                className="group rounded-r-xl px-2 py-[8px] border dark:bg-gray-300 border-gray-200 dark:hover:bg-gray-200 flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                                                <svg
                                                                    className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="12"
                                                                    height="12"
                                                                    viewBox="0 0 22 22"
                                                                    fill="none">
                                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                                    <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={e => {
                                                            handleAddToCart(dados);
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}
                                                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                        <AddShoppingCartRoundedIcon /> Carrinho
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}{' '}
                            </div>
                        </>
                    )}
                    {semDados && !loadingTable && <NotFound frase={t('semRegistos')} />}
                    {loadingTable && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div className="flex flex-row items-center">
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            {catalogoCard && (
                                <div className="flex flex-row ml-4 items-center">
                                    {' '}
                                    <select
                                        onChange={e => {
                                            setITEMS_PER_PAGE(e.target.value);
                                        }}
                                        value={ITEMS_PER_PAGE}
                                        onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        id="small"
                                        className="block  p-2 w-20  text-sm text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                        <option selected>{t('itensPorPagina')}</option>
                                        {numPg.map((e, index) => (
                                            <option key={index} value={e.value}>
                                                {e.label}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{t('itensPorPagina')}</span>
                                </div>
                            )}
                        </div>
                        <div>
                            <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </div>
                    </nav>
                </div>
            )}
        </div>
    );
}

export default Table;
